import {useDispatch} from 'react-redux';
import HotList from './HotList';
import RankingList from './RankingList';
import TodayFreeSeries from './TodayFreeSeries';
import WufPlusList from './WufPlusList';
import useFetchTabV4 from '../../../common/hook/useFetchTabV4';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import useIsLite from '../../../commonSub/hook/useIsLite';
import Messages from '../../common/container/Messages';
import {HomeTabPage} from '../../common/type';
import {actions} from '../state/action';

export default function MainV4() {
  const [currentTab, currentRankingTag] = useTypedSelector(state => {
    const currentTab = state.home.secondTabs[HomeTabPage.Main].selected;
    return [
      currentTab,
      state.main.ranking.tabs.find(({id}) => id === currentTab)?.tag,
    ];
  });
  const isHotTab = currentTab === 'hot';
  const isTodayFreeSeriesTab = currentTab === 'free_publishing';
  const isWufPlusTab = currentTab === 'waitfree';
  const isRankingtab = !isHotTab && !isTodayFreeSeriesTab;
  const isLite = useIsLite();
  const dispatch = useDispatch();
  useFetchTabV4({
    onFetch: () => {
      if (!isRankingtab) return;
      dispatch(
        actions.fetchRankingTabContents({
          tag: currentRankingTag,
          isRealTimeRankingTab: !currentRankingTag,
        })
      );
    },
    changeTab: currentTab,
  });

  return (
    <>
      {isHotTab && <HotList />}
      {isTodayFreeSeriesTab && <TodayFreeSeries />}
      {isWufPlusTab && <WufPlusList />}
      {isRankingtab && <RankingList key={currentRankingTag} />}
      {!isLite && <Messages />}
    </>
  );
}
